import { ConditionalWrapper } from '@shared/ui/conditional-wrapper';
import { Flex, Tooltip, Typography } from 'antd';
import type { FC, TdHTMLAttributes } from 'react';

export type TCellTextTooltipContentProps = TdHTMLAttributes<HTMLTableCellElement> & {
  condition?: boolean;
  tooltipContent: string;
  tooltipText?: number | string;
};

export const TCellTextTooltipContent: FC<TCellTextTooltipContentProps> = ({
  condition,
  tooltipContent,
  tooltipText,
  ...props
}) => {
  const { Text } = Typography;
  return (
    <td {...props}>
      <ConditionalWrapper
        condition={condition || false}
        wrapper={(children) => (
          <Tooltip title={tooltipContent} placement="top">
            {children}
          </Tooltip>
        )}
      >
        <Flex
          align="center"
          justify="center"
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '44px',
            cursor: 'pointer',
          }}
        >
          <Text>{tooltipText || '-'}</Text>
        </Flex>
      </ConditionalWrapper>
    </td>
  );
};
